import { alpha, type Theme } from '@mui/material/styles'

type Owner = { theme: Theme; ownerState: Record<string, unknown> }

const Button = () => ({
  MuiButton: {
    styleOverrides: {
      root: ({ ownerState, theme }: Owner) => ({
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '0.3px',
        // O painel e em PT-BR: rotulo de botao em caixa alta atrapalha a leitura
        // de "Vincular NC à Imagem" e "Submeter para Aprovação".
        textTransform: 'none' as const,
        ...(ownerState.size === 'medium' &&
          ownerState.variant === 'text' && { padding: theme.spacing(1.75, 5) }),
        '&:not(.MuiButtonGroup-grouped)': {
          transition: 'all 0.2s ease-in-out',
          '&:hover': { transform: 'translateY(-1px)' },
        },
      }),
      contained: ({ theme }: Owner) => ({
        boxShadow: theme.shadows[3],
        padding: theme.spacing(1.75, 5),
      }),
      containedPrimary: ({ theme }: Owner) => ({
        '&:not(.Mui-disabled)': { boxShadow: `0 2px 4px 0 ${alpha(theme.palette.primary.main, 0.4)}` },
      }),
      containedSecondary: ({ theme }: Owner) => ({
        '&:not(.Mui-disabled)': { boxShadow: `0 2px 4px 0 ${alpha(theme.palette.secondary.main, 0.4)}` },
      }),
      containedSuccess: ({ theme }: Owner) => ({
        '&:not(.Mui-disabled)': { boxShadow: `0 2px 4px 0 ${alpha(theme.palette.success.main, 0.4)}` },
      }),
      containedError: ({ theme }: Owner) => ({
        '&:not(.Mui-disabled)': { boxShadow: `0 2px 4px 0 ${alpha(theme.palette.error.main, 0.4)}` },
      }),
      containedWarning: ({ theme }: Owner) => ({
        '&:not(.Mui-disabled)': { boxShadow: `0 2px 4px 0 ${alpha(theme.palette.warning.main, 0.4)}` },
      }),
      containedInfo: ({ theme }: Owner) => ({
        '&:not(.Mui-disabled)': { boxShadow: `0 2px 4px 0 ${alpha(theme.palette.info.main, 0.4)}` },
      }),
      outlined: ({ theme }: Owner) => ({ padding: theme.spacing(1.5, 4.75) }),
      sizeSmall: ({ theme, ownerState }: Owner) => ({
        borderRadius: 4,
        ...(ownerState.variant === 'text' && { padding: theme.spacing(1, 3.5) }),
        ...(ownerState.variant === 'contained' && { padding: theme.spacing(1, 3.5) }),
        ...(ownerState.variant === 'outlined' && { padding: theme.spacing(0.75, 3.25) }),
      }),
      sizeLarge: ({ theme, ownerState }: Owner) => ({
        borderRadius: 8,
        ...(ownerState.variant === 'text' && { padding: theme.spacing(2, 6.5) }),
        ...(ownerState.variant === 'contained' && { padding: theme.spacing(2, 6.5) }),
        ...(ownerState.variant === 'outlined' && { padding: theme.spacing(1.75, 6.25) }),
      }),
    },
  },
  MuiButtonBase: {
    defaultProps: { disableRipple: true },
  },
})

export default Button
